module.exports = __webpack_public_path__ + "files/d65e7bbc486ee72c7aafb5dc071f5d89.png";